import { render } from "./component.vue?vue&type=template&id=f95beab2"
import script from "./component.vue?vue&type=script&setup=true&lang=js"
export * from "./component.vue?vue&type=script&setup=true&lang=js"

import "./component.vue?vue&type=style&index=0&id=f95beab2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/plugins/cookies-bar/component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f95beab2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f95beab2', __exports__)) {
    api.reload('f95beab2', __exports__)
  }
  
  module.hot.accept("./component.vue?vue&type=template&id=f95beab2", () => {
    api.rerender('f95beab2', render)
  })

}


export default __exports__